<template>
  <div>
    <v-dialog v-model="showVisioDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Visites en vidéos
        </v-card-title>

        <v-card-text>
          Home in love se charge de la visite pour vous et s'engage à prendre un
          maximum de photo et vidéo du bien, des parties communes et du
          quartier. Home in love se charge de faire maximum 3 visites en visio
          pour vous. En revanche, compte tenu du marché immobilier tendu, il ne
          pourra pas y avoir de contre visite. Ainsi si nous déposons un dossier
          et que celui-ci est accepté, vous vous engagez à signer le bail d'un
          appartement que vous n'aurez pas vu.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.stop="addVisio()">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="mx-3 my-3 px-2 py-3">
      <h2>Services</h2>
      <div class="h6">
        Nous proposons la mise en relation et l’établissement des devis avec des
        services complémentaires, dont vous pourriez avoir besoin dans le cadre
        de votre mobilité. Ces services sont facultatifs et ne vous engagent
        nullement à contractualiser avec nos partenaires
      </div>
      <v-list>
        <v-list-tile v-for="s in servicesList">
          <v-list-tile-action>
            <v-checkbox
              :value="isSelected(s)"
              v-if="!isDone(s)"
              @change="toggleService(s)"
            ></v-checkbox>
            <v-icon v-else>check</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            {{ s }}
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import { SERVICES } from "../../data/DefaultSettings";

export default {
  name: "ProjectServices",
  props: ["value", "project"],
  data() {
    return {
      showVisioDialog: false,
      instance: {
        services: []
      }
    };
  },
  computed: {
    servicesList() {
      return SERVICES;
    }
  },
  mounted() {
    if (this.project != null) {
      const { services } = this.project;
      this.instance = {
        services
      };
      this.$emit("input", { ...this.instance });
    } else {
      this.$emit("input", { ...this.instance });
    }
  },
  methods: {
    isSelected(service) {
      return this.instance.services.filter(s => s.name === service).length > 0;
    },
    isDone(service) {
      return (
        this.isSelected(service) &&
        this.instance.services.filter(s => s.name === service)[0].done
      );
    },

    addVisio() {
      this.showVisioDialog = false;
      this.instance.services.push({
        name: "Visites en visio-conférence",
        done: null
      });
      this.$emit("input", { ...this.instance });
    },

    toggleService(service) {
      if (this.isSelected(service)) {
        this.instance.services = this.instance.services.filter(
          s => service !== s.name
        );
      } else {
        if (service === "Visites en visio-conférence") {
          this.showVisioDialog = true;
        } else {
          this.instance.services.push({
            name: service,
            done: null
          });
        }
      }
      this.$emit("input", { ...this.instance });
    }
  }
};
</script>

<style scoped></style>
